<template>
  <div
    class="create-payment__additional-fields"
    v-if="paymentType.slug === paymentTypesConst.requisitesPayment"
  >
    <div class="create-payment__field create-payment__field--select">
      <div class="create-payment__field-label">
        {{ $t("create_payment.requisites_template.title") }}
      </div>
      <div class="create-payment__field-block">
        <v-select
          v-model="selectedRequisitesTemplate"
          :options="requisitesTemplatesDataset"
          :placeholder="$t('create_payment.requisites_template.placeholder')"
        ></v-select>
      </div>
    </div>
    <div class="create-payment__field">
      <text-input
        view="line"
        :title="$t('create_payment.recipient_iban')"
        :placeholder="$t('create_payment.recipient_iban.placeholder')"
        v-model="iban"
        :errors="v$.iban.$errors"
        :mask="'UA#############################'"
      ></text-input>
    </div>
    <div class="create-payment__field">
      <text-input
        :title="$t('create_payment.recipient_okpo')"
        :placeholder="$t('create_payment.recipient_okpo.placeholder')"
        v-model="okpo"
        view="line"
        :errors="v$.okpo.$errors"
        :mask="'##########'"
      ></text-input>
    </div>
    <div class="create-payment__field">
      <text-input
        view="line"
        :title="$t('create_payment.recipient_name')"
        :placeholder="$t('create_payment.recipient_name.placeholder')"
        :errors="v$.recipientName.$errors"
        v-model="recipientName"
      ></text-input>
    </div>
    <div
      class="create-payment__field create-payment__field--cbc"
      v-if="ibanWithPurposeTemplate"
    >
      <text-input
        view="line"
        v-model="cbcCode"
        :errors="v$.cbcCode.$errors"
        title="Код бюджетної класифікації"
        :mask="$options.NUMBER_MASK"
      ></text-input>
      <div class="create-payment__field--cbc-hint">
        <a
          href="https://zakon.rada.gov.ua/rada/show/v0011201-11#Text"
          target="_blank"
          >Список кодів бюджетної класифікації</a
        >
      </div>
    </div>
    <div class="create-payment__field">
      <text-area
        view="line"
        :title="$t('create_payment.purpose')"
        :placeholder="$t('create_payment.purpose.placeholder')"
        :errors="
          v$.purpose && v$.purpose.$errors
            ? v$.purpose.$errors
            : externalErrors.purpose
            ? externalErrors.purpose
            : []
        "
        v-model="purpose"
      ></text-area>
    </div>
  </div>
  <div class="create-payment__additional-fields" v-else>
    <div
      class="create-payment__field create-payment__field--select"
      :class="{
        'create-payment__field--error':
          v$.selectedPaymentTypeOption.$errors.length > 0,
      }"
    >
      <div class="create-payment__field-label">
        {{ $t("create_payment.payment_type_option") }}
      </div>
      <div class="create-payment__field-block">
        <v-select
          v-model="selectedPaymentTypeOption"
          :options="paymentTypeOptionsDataSet"
          :placeholder="$t('create_payment.payment_type_option.placeholder')"
        ></v-select>
        <div
          class="create-payment__field-errors"
          v-if="v$.selectedPaymentTypeOption.$errors.length > 0"
        >
          <div class="create-payment__field-error">
            {{ $t(v$.selectedPaymentTypeOption.$errors[0].$message) }}
          </div>
        </div>
      </div>
    </div>
    <div
      class="create-payment__field create-payment__field--select"
      v-if="
        paymentType.slug === paymentTypesConst.adminPayment ||
        paymentType.slug === paymentTypesConst.adminGovernmentPayment
      "
      :class="{
        'create-payment__field--error':
          v$.selectedPaymentTypeOptionTerm.$errors.length > 0,
      }"
    >
      <div class="create-payment__field-label">
        {{ $t("create_payment.payment_type_option_term") }}
      </div>
      <div class="create-payment__field-block">
        <v-select
          v-model="selectedPaymentTypeOptionTerm"
          :options="paymentTypeOptionTermsDataSet"
          :placeholder="
            $t('create_payment.payment_type_option_term.placeholder')
          "
        ></v-select>
        <div
          class="create-payment__field-errors"
          v-if="v$.selectedPaymentTypeOptionTerm.$errors.length > 0"
        >
          <div class="create-payment__field-error">
            {{ $t(v$.selectedPaymentTypeOptionTerm.$errors[0].$message) }}
          </div>
        </div>
      </div>
    </div>
    <div
      class="create-payment__field create-payment__field--select"
      :class="{
        'create-payment__field--error':
          v$.selectedPaymentTypeRegion.$errors.length > 0,
      }"
    >
      <div class="create-payment__field-label">
        {{ $t("create_payment.payment_type_region") }}
      </div>
      <div class="create-payment__field-block">
        <v-select
          v-model="selectedPaymentTypeRegion"
          :options="paymentTypeRegionsDataSet"
          :placeholder="$t('create_payment.payment_type_region.placeholder')"
        ></v-select>
        <div
          class="create-payment__field-errors"
          v-if="v$.selectedPaymentTypeRegion.$errors.length > 0"
        >
          <div class="create-payment__field-error">
            {{ $t(v$.selectedPaymentTypeRegion.$errors[0].$message) }}
          </div>
        </div>
      </div>
    </div>
    <div
      class="create-payment__field create-payment__field--select"
      :class="{
        'create-payment__field--error':
          v$.selectedPaymentTypeRequisite.$errors.length > 0,
      }"
    >
      <div class="create-payment__field-label">
        {{ $t("create_payment.payment_type_recipient") }}
      </div>
      <div class="create-payment__field-block">
        <v-select
          v-model="selectedPaymentTypeRequisite"
          :options="paymentTypeRequisitesDataSet"
          :placeholder="$t('create_payment.payment_type_recipient.placeholder')"
        ></v-select>
        <div
          class="create-payment__field-errors"
          v-if="v$.selectedPaymentTypeRequisite.$errors.length > 0"
        >
          <div class="create-payment__field-error">
            {{ $t(v$.selectedPaymentTypeRequisite.$errors[0].$message) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ADMIN_GOVERNMENT_PAYMENT,
  ADMIN_PAYMENT,
  REGISTRY_PAYMENT,
  REQUISITES_PAYMENT,
} from "@/const/payment-types";
import { PaymentTypeApi } from "@/office/payment/payment-type-api";
import TextInput from "@/components/inputs/TextInput";
import TextArea from "@/components/inputs/TextAreaInput";
import useVuelidate from "@vuelidate/core";
import { helpers, maxLength, required, minLength } from "@vuelidate/validators";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import { ibanBalanceByOkpo } from "@/validators/custom";

const numberMask = createNumberMask({
  prefix: "",
  allowDecimal: true,
  includeThousandsSeparator: false,
  allowNegative: false,
  locale: "ru",
});

const purposeTemplateValidation = (value) => {
  value = value.replaceAll("...", "");

  let _regEx = new RegExp(
    "\\*;[0-9]{3};[0-9а-яА-ЯіІїЇґҐєЄ]{8,10};([^;]*);([^;]*);([^;]*);",
    "gim"
  );

  return _regEx.test(value);
};

export default {
  name: "CreatePaymentAdditionalFields",
  components: { TextArea, TextInput },
  model: {
    prop: "value",
    event: "update",
  },
  props: {
    paymentType: {
      type: Object,
      required: true,
    },
    repeatOrderObject: {},
    client: {
      type: Object,
    },
    externalErrors: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  NUMBER_MASK: numberMask,

  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  data() {
    return {
      paymentTypeOptions: [],
      paymentTypeOptionTerms: [],
      paymentTypeRegions: [],
      paymentTypeRequisites: [],
      requisitesTemplates: [],
      selectedPaymentTypeOption: null,
      selectedPaymentTypeRegion: null,
      selectedPaymentTypeRequisite: null,
      selectedPaymentTypeOptionTerm: null,
      selectedRequisitesTemplate: null,
      requisitePaymentAmount: null,
      iban: "",
      okpo: "",
      cbcCode: "",
      recipientName: "",
      purpose: "",
      paymentTypesConst: {
        adminPayment: ADMIN_PAYMENT,
        adminGovernmentPayment: ADMIN_GOVERNMENT_PAYMENT,
        registryPayment: REGISTRY_PAYMENT,
        requisitesPayment: REQUISITES_PAYMENT,
      },
      additionalFieldsFirstLoad: false,
      ibanWithTemplateActive: false,
    };
  },
  validations() {
    let validationsObject = {
      selectedPaymentTypeOption: {
        required: helpers.withMessage("payment_type_option_required", required),
      },
      selectedPaymentTypeRegion: {
        required: helpers.withMessage("payment_type_region_required", required),
      },
      selectedPaymentTypeRequisite: {
        required: helpers.withMessage(
          "payment_type_requisite_required",
          required
        ),
      },
    };

    switch (this.paymentType.slug) {
      case this.paymentTypesConst.adminPayment:
      case this.paymentTypesConst.adminGovernmentPayment: {
        return {
          ...validationsObject,
          selectedPaymentTypeOptionTerm: {
            required: helpers.withMessage(
              "payment_type_option_term_required",
              required
            ),
          },
        };
      }
      case this.paymentTypesConst.registryPayment: {
        return { ...validationsObject };
      }
      case this.paymentTypesConst.requisitesPayment: {
        let _requisitesValidations = {
          iban: {
            required: helpers.withMessage("iban_required", required),
						ibanBalanceByOkpo: helpers.withMessage(
							"iban_balance_code_by_okpo_rule",
							ibanBalanceByOkpo(() => this.okpo)
						),
          },
          okpo: {
            required: helpers.withMessage("okpo_required", required),
          },
          recipientName: {
            required: helpers.withMessage("recipient_name_required", required),
            maxLength: helpers.withMessage(
              "recipient_name_max_length",
              maxLength(75)
            ),
          },
        };

        if (this.ibanWithTemplateActive) {
          _requisitesValidations = {
            ..._requisitesValidations,
            purpose: {
              maxLength: helpers.withMessage(
                "purpose_max_height",
                maxLength(160)
              ),
              validPurpose: helpers.withMessage(
                "purpose_invalid",
                purposeTemplateValidation
              ),
            },
          };

          if (this.ibanWithPurposeTemplate) {
            _requisitesValidations["cbcCode"] = {
              required: required,
              length: helpers.withMessage("cbc_length", minLength(8)),
              mLength: helpers.withMessage("cbc_length", maxLength(8)),
            };
          }
        } else {
          _requisitesValidations = {
            ..._requisitesValidations,
            purpose: {
              maxLength: helpers.withMessage(
                "purpose_max_height",
                maxLength(160)
              ),
            },
          };
        }
        return { ..._requisitesValidations };
      }
    }
  },
  async created() {
    await this.loadAdditionalFields();

    if (this.repeatOrderObject !== null) {
      this.setRepeatOrderData();
    }
  },
  watch: {
    cbcCode() {
      let _purpose = this.purpose.split(";");

      _purpose[3] = this.cbcCode;

      this.purpose = _purpose.join(";");
    },
    paymentType: function () {
      if (this.paymentType !== null) {
        this.loadAdditionalFields();
      }
    },
    selectedPaymentTypeRegion: function () {
      if (this.selectedPaymentTypeRegion === null) {
        this.paymentTypeRequisites = [];
      } else {
        new PaymentTypeApi()
          .loadRequisitesByRegion(
            this.selectedPaymentTypeRegion.id,
            this.paymentType.id
          )
          .then((r) => {
            this.paymentTypeRequisites = r.data.requisites;
          });
      }

      this.updateData();
    },
    selectedPaymentTypeOption: function () {
      if (this.selectedPaymentTypeOption === null) {
        this.paymentTypeOptionTerms = [];
      } else {
        new PaymentTypeApi()
          .loadTermsByOption(this.selectedPaymentTypeOption.id)
          .then((r) => {
            this.paymentTypeOptionTerms = r.data.terms;
          });
      }

      this.updateData();
    },
    selectedPaymentTypeRequisite: function () {
      this.updateData();
    },
    selectedPaymentTypeOptionTerm: function () {
      if (
        this.paymentType.slug !== this.paymentTypesConst.adminPayment &&
        this.paymentType.slug !== this.paymentTypesConst.adminGovernmentPayment
      ) {
        return false;
      }

      this.updateData();
    },
    iban: function () {
      this.ibanWithTemplateActive = !!this.ibanWithPurposeTemplate;

      this.updateData();
    },
    ibanWithTemplateActive: function () {
      if (
        this.selectedRequisitesTemplate !== null &&
        this.selectedRequisitesTemplate.id !== null
      ) {
        return;
      }

      if (this.ibanWithPurposeTemplate) {
        this.purpose = `*;101;${this.client.inn};${this.cbcCode};Платіж до бюджету;...;...`;
      } else {
        this.purpose = `*;101;${this.client.inn};${this.client.full_name};;;`;
      }
    },
    okpo: function () {
      this.updateData();
    },
    recipientName: function () {
      this.updateData();
    },

    purpose: function () {
      this.updateData();
    },
    selectedRequisitesTemplate: function () {
      if (
        this.selectedRequisitesTemplate !== null &&
        this.selectedRequisitesTemplate.id !== null &&
        this.selectedRequisitesTemplate.id !== "reset"
      ) {
        console.log(123);
        let requisiteTemplate = this.requisitesTemplates.find(
          (_rT) => _rT.id === this.selectedRequisitesTemplate.id
        );
        this.requisitePaymentAmount = requisiteTemplate.amount;
        this.recipientName = requisiteTemplate.recipient_name;
        this.iban = requisiteTemplate.recipient_iban;
        this.okpo = requisiteTemplate.recipient_code;
        this.purpose = requisiteTemplate.comment
          .replace("{clientName}", this.client.full_name)
          .replace("{clientIPN}", this.client.inn);
        this.updateData();
      } else {
        this.requisitePaymentAmount = null;
        this.recipientName = "";
        this.iban = "";
        this.okpo = "";
        this.purpose = `${this.client.full_name} ${this.client.inn}`;
      }
    },
  },
  computed: {
    ibanWithPurposeTemplate() {
      return this.iban[4] && this.iban[4].toString() === "8";
    },
    paymentTypeOptionsDataSet() {
      return this.paymentTypeOptions.map((pTO) => ({
        id: pTO.id,
        label: pTO.name,
        additionalData: pTO.additional_data,
      }));
    },
    paymentTypeRegionsDataSet() {
      return this.paymentTypeRegions.map((pTR) => ({
        id: pTR.id,
        label: pTR.name,
      }));
    },
    paymentTypeRequisitesDataSet() {
      return this.paymentTypeRequisites.map((pTR) => ({
        id: pTR.id,
        label: pTR.name,
      }));
    },
    paymentTypeOptionTermsDataSet() {
      return this.paymentTypeOptionTerms.map((pTOT) => ({
        id: pTOT.id,
        label: pTOT.period,
        tax: pTOT.tax,
      }));
    },
    requisitesTemplatesDataset() {
      return [
        {
          id: "reset",
          label: this.$t("create_payment.requisites_template.option.reset"),
        },
        ...this.requisitesTemplates.map((rT) => ({
          id: rT.id,
          label: rT.title,
        })),
      ];
    },
    paymentAmount() {
      if (
        this.paymentType.slug === this.paymentTypesConst.adminPayment ||
        this.paymentType.slug === this.paymentTypesConst.adminGovernmentPayment
      ) {
        return this.selectedPaymentTypeOptionTerm
          ? this.selectedPaymentTypeOptionTerm.tax
          : 0;
      } else if (
        this.paymentType.slug === this.paymentTypesConst.registryPayment
      ) {
        return this.selectedPaymentTypeOption
          ? this.selectedPaymentTypeOption.additionalData.tariff
          : 0;
      } else if (
        this.paymentType.slug === this.paymentTypesConst.requisitesPayment &&
        this.requisitePaymentAmount !== null
      ) {
        return this.requisitePaymentAmount;
      }

      return 0;
    },
  },
  methods: {
    async loadAdditionalFields() {
      this.paymentTypeRegions = [];
      this.paymentTypeOptions = [];
      this.paymentTypeRequisites = [];

      if (this.additionalFieldsFirstLoad) {
        this.selectedPaymentTypeRegion = null;
        this.selectedPaymentTypeOption = null;
        this.selectedPaymentTypeRequisite = null;
      }

      if (this.paymentType.slug === REQUISITES_PAYMENT) {
        try {
          let requisitesTemplatesResponse =
            await new PaymentTypeApi().loadRequisitesTemplates();
          this.requisitesTemplates =
            requisitesTemplatesResponse.data.requisites_templates;
        } catch (e) {
          console.error(e);
        }

        if (this.purpose.trim().length === 0) {
          this.purpose = `${this.client.full_name} ${this.client.inn}`;
        }

        return false;
      }

      await new PaymentTypeApi()
        .getPaymentTypeFields(this.paymentType.id)
        .then((r) => {
          this.paymentTypeOptions = r.data.options;
          this.paymentTypeRegions = r.data.regions;
          this.additionalFieldsFirstLoad = true;
        });
    },
    updateData() {
      this.$emit("update", {
        payment_type_region_id: this.selectedPaymentTypeRegion
          ? this.selectedPaymentTypeRegion.id
          : null,
        payment_type_option_id: this.selectedPaymentTypeOption
          ? this.selectedPaymentTypeOption.id
          : null,
        payment_type_requisite_id: this.selectedPaymentTypeRequisite
          ? this.selectedPaymentTypeRequisite.id
          : null,
        payment_type_option_term_id: this.selectedPaymentTypeOptionTerm
          ? this.selectedPaymentTypeOptionTerm.id
          : null,
        amount: this.paymentAmount,
        iban: this.paymentType.slug === REQUISITES_PAYMENT ? this.iban : null,
        okpo: this.paymentType.slug === REQUISITES_PAYMENT ? this.okpo : null,
        recipient_name: this.recipientName,
        purpose: this.getFormattedPurpose().replaceAll("...", ""),
        requisites_template: this.selectedRequisitesTemplate,
        cbc_code: this.cbcCode,
      });
    },
    setRepeatOrderData() {
      if (this.paymentType.slug === REQUISITES_PAYMENT) {
        this.okpo = this.repeatOrderObject.orderItem.okpo;
        this.iban = this.repeatOrderObject.orderItem.iban;
        this.recipientName = this.repeatOrderObject.orderItem.recipient_name;
        this.purpose = this.repeatOrderObject.orderItem.purpose;
      }

      if (this.repeatOrderObject.paymentData.payment_type_option) {
        this.selectedPaymentTypeOption = {
          id: this.repeatOrderObject.paymentData.payment_type_option.id,
          label: this.repeatOrderObject.paymentData.payment_type_option.name,
          additionalData:
            this.repeatOrderObject.paymentData.payment_type_option
              .additional_data,
        };
      }

      if (this.repeatOrderObject.paymentData.payment_type_region) {
        this.selectedPaymentTypeRegion = {
          id: this.repeatOrderObject.paymentData.payment_type_region.id,
          label: this.repeatOrderObject.paymentData.payment_type_region.name,
        };
      }

      if (this.repeatOrderObject.paymentData.payment_type_requisite) {
        this.selectedPaymentTypeRequisite = {
          id: this.repeatOrderObject.paymentData.payment_type_requisite.id,
          label: this.repeatOrderObject.paymentData.payment_type_requisite.name,
        };
      }

      if (this.repeatOrderObject.paymentData.payment_type_option_term) {
        this.selectedPaymentTypeOptionTerm = {
          id: this.repeatOrderObject.paymentData.payment_type_option_term.id,
          label:
            this.repeatOrderObject.paymentData.payment_type_option_term.period,
          tax: this.repeatOrderObject.paymentData.payment_type_option_term.tax,
        };
      }

      this.repeatOrderObject = null;
      this.$emit("repeatOrderSet");
    },
    async validate() {
      this.v$.$reset();
      return await this.v$.$validate();
    },
    getFormattedPurpose() {
      if (this.ibanWithTemplateActive) {
        let _purposeParts = this.purpose.split(";");

        if (_purposeParts.length !== 7) {
          return this.purpose;
        }

        let formattedPurpose = `${_purposeParts.shift()};${_purposeParts.shift()};${_purposeParts.shift()};${_purposeParts
          .join(" ")
          .trim()};;;`;
        return formattedPurpose;
      }

      return this.purpose;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";
@import "~@/assets/scss/_mixins.scss";

.create-payment {
  &__additional-fields {
    padding-left: 100px;
    margin-bottom: 24px;
  }

  &__field {
    width: 100%;
    display: flex;
    align-items: center;

    margin-bottom: 25px;

    &--cbc {
      display: flex;
      flex-direction: column;

      &-hint {
        margin-left: auto;
        text-align: right;
        margin-top: 5px;

        a {
          color: #5c91f2;
        }
      }
    }

    &-toggles {
      margin-right: 20px;

      display: flex;
      align-items: center;
      gap: 10px;

      ::v-deep .checkbox-input__text {
        white-space: nowrap;
      }
    }

    &:last-child {
      margin-bottom: 0;
    }

    &-label {
      color: $textLight;
      font-size: pxToRem(10);
      line-height: pxToRem(12);
      margin-right: 44px;
      width: 100px;
      word-wrap: break-word;
      flex-shrink: 0;
      flex-grow: 0;
    }
  }
}
</style>
